/* eslint-disable max-lines */
/* eslint-disable camelcase */
/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import { MModel, MRuleGroup } from 'types';

type ResourceFilterProps = {
  campaign: MModel;
  rules: (MRuleGroup & { render: boolean })[];
  filterCampaigns: string[];
  notFilterCampaigns: string[];
  filterRules: string[];
  notFilterRules: string[];
  handleInputChange: (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    shiftKeyPress: boolean,
    id: string,
    checked: string | undefined,
    isRule: boolean
  ) => void;
};

const CategoriesFilterItem: React.FC<ResourceFilterProps> = (props) => {
  const {
    campaign,
    rules,
    filterCampaigns,
    filterRules,
    notFilterCampaigns,
    notFilterRules,
    handleInputChange,
  } = props;

  const [isOpen, setIsOpen] = useState(false);

  const allFilterItems = [
    ...filterCampaigns,
    ...filterRules,
    ...notFilterCampaigns,
    ...notFilterRules,
  ];

  const negated = notFilterCampaigns.includes(campaign.uuid);
  const selectedRules = rules.filter((r) => allFilterItems.includes(r.uuid));

  const handleCampaignChange = (event: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
    const { shiftKey: exclude } = event.nativeEvent;
    const { id: state } = event.currentTarget;

    const checked = event.currentTarget.dataset.checked === 'true' ? 'false' : 'true';

    handleInputChange(event, exclude, state, checked, false);

    rules
      .filter((r) => allFilterItems.includes(r.uuid))
      .forEach((r) => {
        handleInputChange(event, notFilterCampaigns.includes(campaign.uuid), r.uuid, 'false', true);
      });
  };

  const handleRuleChange = (event: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
    const { shiftKey: exclude } = event.nativeEvent;
    const { id: state } = event.currentTarget;

    if (allFilterItems.includes(state) || allFilterItems.includes(campaign.uuid)) {
      handleInputChange(event, exclude, state, 'false', true);
    } else if (
      !exclude &&
      !allFilterItems.includes(state) &&
      rules.filter((r) => r.uuid !== state).every((r) => filterRules.includes(r.uuid))
    ) {
      handleInputChange(event, exclude, campaign.uuid, 'true', false);
      rules
        .filter((r) => r.uuid !== state)
        .forEach((r) => {
          handleInputChange(event, exclude, r.uuid, 'false', true);
        });
    } else if (
      exclude &&
      !allFilterItems.includes(state) &&
      rules.filter((r) => r.uuid !== state).every((r) => notFilterRules.includes(r.uuid))
    ) {
      handleInputChange(event, exclude, campaign.uuid, 'true', false);
      rules
        .filter((r) => r.uuid !== state)
        .forEach((r) => {
          handleInputChange(event, exclude, r.uuid, 'false', true);
        });
    } else {
      handleInputChange(event, exclude, state, 'true', true);
    }

    if (allFilterItems.includes(campaign.uuid)) {
      handleInputChange(event, exclude, campaign.uuid, 'false', false);
      rules
        .filter((r) => r.uuid !== state && !allFilterItems.includes(r.uuid))
        .forEach((r) => {
          handleInputChange(
            event,
            notFilterCampaigns.includes(campaign.uuid),
            r.uuid,
            'true',
            true
          );
        });
    }
  };

  return (
    <>
      <div
        id={campaign.uuid}
        role="button"
        aria-hidden
        className="w-full py-1 pr-2 relative flex flex-row items-base cursor-pointer"
        data-checked={allFilterItems.includes(campaign.uuid)}
      >
        <div
          id={campaign.uuid}
          aria-hidden
          className="pl-2 pr-1 flex flex-row items-base cursor-pointer focus:outline-none"
          onClick={(e): void => handleCampaignChange(e)}
          data-checked={allFilterItems.includes(campaign.uuid)}
        >
          <input
            id={campaign.uuid}
            data-testid={`${campaign.uuid}-checkbox`}
            type="checkbox"
            className={`form-checkbox litlingo-checkbox h-4 w-4 transition duration-150 ease-in-out cursor-pointer
          ${rules.length > 0 && selectedRules.length > 0 ? 'checkbox-select-all-partial' : ''}
          ${negated ? 'litlingo-checkbox-negated' : 'litlingo-checkbox'}`}
            checked={allFilterItems.includes(campaign.uuid)}
          />
        </div>

        <div
          aria-hidden
          className="ml-1 w-full flex flex-row justify-between gap-1 text-small"
          onClick={(e): void => {
            e.stopPropagation();
            if (rules.length > 0) {
              setIsOpen(!isOpen);
            }
          }}
        >
          <span className="w-full select-none font-semibold" style={{ wordBreak: 'break-word' }}>
            {campaign.name}
          </span>
          <span className="text-litlingo-primary">
            {/* @ts-ignore */}
            {!campaign.count && campaign.count !== 0 ? '-' : campaign.count}
          </span>
        </div>
        {rules.length > 0 && (
          <button
            type="button"
            onClick={(e): void => {
              e.stopPropagation();
              setIsOpen(!isOpen);
            }}
            className="h-4 pl-1 focus:outline-none"
          >
            <svg
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className={`${isOpen ? 'transform rotate-90' : ''}`}
            >
              <path
                d="M2.08961 9.91604C2.1425 9.96937 2.21437 9.99955 2.28948 9.99999C2.32675 10.0003 2.3637 9.99307 2.39807 9.97864C2.43244 9.9642 2.4635 9.9429 2.48934 9.91604L7.20219 5.20319C7.22866 5.17707 7.24968 5.14595 7.26402 5.11164C7.27837 5.07733 7.28575 5.04051 7.28575 5.00333C7.28575 4.96614 7.27837 4.92932 7.26402 4.89501C7.24968 4.8607 7.22866 4.82958 7.20219 4.80346L2.48934 0.0896109C2.46343 0.0619091 2.43221 0.0397035 2.39754 0.0243155C2.36287 0.00892748 2.32545 0.000671647 2.28753 3.93014e-05C2.2496 -0.000593044 2.21193 0.00641102 2.17677 0.0206347C2.1416 0.0348583 2.10966 0.0560109 2.08283 0.0828334C2.05601 0.109656 2.03486 0.1416 2.02063 0.176766C2.00641 0.211931 1.99941 0.249598 2.00004 0.287526C2.00067 0.325453 2.00893 0.362866 2.02432 0.397537C2.0397 0.432209 2.06191 0.46343 2.08961 0.489344L6.6026 5.00333L2.08961 9.51631C2.06326 9.5425 2.04235 9.57364 2.02809 9.60794C2.01382 9.64224 2.00647 9.67903 2.00647 9.71618C2.00647 9.75333 2.01382 9.79011 2.02809 9.82441C2.04235 9.85871 2.06326 9.88985 2.08961 9.91604Z"
                fill="#333333"
              />
            </svg>
          </button>
        )}
      </div>
      <div>
        {isOpen &&
          rules
            .filter((r) => r.render)
            .map((ruleItem) => {
              const ruleNegated =
                notFilterRules.includes(ruleItem.uuid) ||
                notFilterCampaigns.includes(campaign.uuid);

              return (
                <div
                  id={ruleItem.uuid}
                  key={ruleItem.uuid}
                  role="button"
                  aria-hidden
                  className="w-full py-1 px-2 bg-white relative flex flex-row items-start cursor-pointer"
                  data-checked={allFilterItems.includes(ruleItem.uuid)}
                  onClick={(e): void => handleRuleChange(e)}
                >
                  <input
                    id={ruleItem.uuid}
                    data-testid={`${ruleItem.uuid}-checkbox`}
                    type="checkbox"
                    className={`form-checkbox litlingo-checkbox mr-1 h-4 w-4 transition duration-150 ease-in-out cursor-pointer ${
                      ruleNegated ? 'litlingo-checkbox-negated' : 'litlingo-checkbox'
                    }`}
                    checked={
                      allFilterItems.includes(ruleItem.uuid) ||
                      allFilterItems.includes(campaign.uuid)
                    }
                  />

                  <label
                    htmlFor={ruleItem.uuid}
                    className="w-full flex flex-row justify-between gap-1 text-small cursor-pointer"
                  >
                    <span className="w-full select-none" style={{ wordBreak: 'break-word' }}>
                      {ruleItem.name}
                    </span>
                    <span className="text-litlingo-primary">
                      {/* @ts-ignore */}
                      {!ruleItem.count && ruleItem.count !== 0 ? '-' : ruleItem.count}
                    </span>
                  </label>
                </div>
              );
            })}
      </div>
    </>
  );
};

export default CategoriesFilterItem;
